import { render, staticRenderFns } from "./AddonNote.vue?vue&type=template&id=408e2b7a&"
import script from "./AddonNote.vue?vue&type=script&lang=js&"
export * from "./AddonNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports